exports.linkResolver = (doc) => {
    const uid = doc.uid ? doc.uid.toLowerCase() : '';

    if (doc.type === 'symmetry_article') {
        return `/payroll-tax-insights/${uid}`;
    }
    if (doc.type === 'symmetry_customer') {
        return `/customer-stories/${uid}`;
    }
    if (doc.type === 'symmetry_category') {
        return `/payroll-tax-insights/${uid}`;
    }
    if (doc.type === 'symmetry_marketing_page') {
        return `/${uid}`;
    }
    if (doc.type === 'symmetry_webinar') {
        return `/webinars/${uid}`;
    }

    return '/';
};
